<script>
import SearchCrewModal from "@/components/elements/SearchCrewModal.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {RankService} from "@/services/RankService";
import {dataMixin} from "@/mixins/dataMixin";

export default {
  name: "OBListModal",
  components: {SearchCrewModal},
  mixins: [vueAppMixin, dataMixin],
  props: ['oblist', "oblistIndex", "manning", 'default_rank'],
  emits: ['return-crew', 'return-additional-crew'],
  data() {
    return {
      ranks: [],
      is_for_promotion: false
    }
  },

  methods: {
      ...mapActions([
        "getRankKeys"
      ]),

    ...mapMutations([
       "setObListModalVisibility"
    ]),

    changeVisibility(hasNotChosenCrew) {
      this.setObListModalVisibility(false);
      if (hasNotChosenCrew) this.is_for_promotion = false;
    },

      async carryOver(crew) {
        if (this.$props["oblistIndex"] > -1) {
          let rank = this.ranks.find(rank => rank.name === crew.rankName);

          if (this.is_for_promotion) {
            if (this.$props.oblist[this.$props.oblistIndex].disembarking_crew_activity) {
              let disembarking_crew = this.$props.oblist[this.$props.oblistIndex].disembarking_crew_activity.crew;

              if (rank.id === disembarking_crew.rank_id) {
                this.errorAlert("Same rank cannot be added to the planned promotion onboard.", "Selection");
                this.is_for_promotion = false;
                return;
              }

              if (rank.id < disembarking_crew.rank_id) {
                this.errorAlert("A higher rank cannot be added to the planned promotion onboard.", "Selection");
                this.is_for_promotion = false;
                return;
              }

              let next_rank = await RankService.getNextRank({
                rank_id: rank.id
              });

              if (disembarking_crew.rank_id !== next_rank.id) {
                this.errorAlert("The next rank of the selected crew reliever is " + next_rank.name, "Selection");
                this.is_for_promotion = false;
                return;
              }
            }
          }

          if (this.$props.oblist[this.$props.oblistIndex].disembarking_crew_activity && !this.is_for_promotion) {
            let disembarking_crew = this.$props.oblist[this.$props.oblistIndex].disembarking_crew_activity.crew;

            if (rank.id > disembarking_crew.rank_id) {
              this.errorAlert("Cannot act as a crew reliever for " + this.fullName(disembarking_crew), "Selection");
              this.is_for_promotion = false;
              return;
            }

            if (disembarking_crew.rank_id !== rank.id) {
              let next_rank = await RankService.getNextRank({
                rank_id: disembarking_crew.rank_id
              });

              if (next_rank === null) {
                if (rank.id !== disembarking_crew.rank_id) {
                  this.errorAlert("Cannot act as a crew reliever for " + this.fullName(disembarking_crew), "Selection");
                  this.is_for_promotion = false;
                  return;
                }
              } else if (next_rank.id !== rank.id) {
                this.errorAlert("Cannot act as a crew reliever for " + this.fullName(disembarking_crew), "Selection");
                this.is_for_promotion = false;
                return;
              }
            }
          }

          this.$emit("return-crew", crew.id, this.is_for_promotion);
          this.is_for_promotion = false;
        } else {
          this.$emit("return-additional-crew", crew.id, this.is_for_promotion);
          this.is_for_promotion = false;
        }
      }
  },

  computed: {
    ...mapGetters([
      "crews",
      "manningKeys",
      "rankKeys",
      "oblistModalVisibility"
    ]),

    filteredCrewList() {
      let onboard_crew_ids = [];
      let onboard_crew_id = 0;

      if (this.$props['oblistIndex'] === -1 || (this.$props['oblistIndex'] > -1 && this.$props.oblist[this.$props.oblistIndex].disembarking_crew_activity === '')) {
        onboard_crew_ids = this.$props.oblist.map((obEntry) => {
          if (obEntry.disembarking_crew_activity) {
            return obEntry.disembarking_crew_activity.crew.id;
          }
        });
      } else if (this.$props['oblistIndex'] > -1 && this.$props.oblist[this.$props.oblistIndex].disembarking_crew_activity !== '') {
        onboard_crew_id = this.$props.oblist[this.$props.oblistIndex].disembarking_crew_activity.crew.id;
      }

      let crew_reliever_ids = this.$props.oblist.map((obEntry) => {
        if (obEntry.crew_reliever) {
          return obEntry.crew_reliever.id
        }
      });

      let crew_ids = onboard_crew_ids.concat(crew_reliever_ids);
      crew_ids.push(onboard_crew_id);

      return this.crews.filter(crew => !crew_ids.includes(crew.id));
    }
  },

  watch: {
    default_rank(newValue) {
      if (newValue === 0) {
        this.getRankKeys();
        return;
      }

      let rankKey = this.ranks.find(rankKey => rankKey.id === newValue);

      this.getRankKeys({
        rank_type_id: rankKey.rank_type_id
      });
    }
  },

  async created() {
    this.ranks = await RankService.getRankKeys();
  }
}
</script>

<template>
  <search-crew-modal
  title="Search Crew"
  unique="searchCrew"
  :manning="manning"
  :visibility="oblistModalVisibility"
  :rank="default_rank"
  :crew-list="filteredCrewList"
  @update_visibility="changeVisibility"
  @return-crew="carryOver">

    <template #optional_fields>
      <div class="d-flex mb-4 mt-4">

        <div class="px-2 py-2 rounded" style="border: 1px solid #21201f">
          <h5 class="text-left font-weight-bold p-1" style="font-size: 1em; background-color: white; margin-top: -20px">Selected Crew Tagging</h5>
          <div class="d-flex">
            <div class="form-check text-left mb-2 mr-2">
              <input id="is_for_promotion" type="checkbox" class="form-check-input" v-model="is_for_promotion">
              <label for="is_for_promotion" class="form-check-label font-weight-bold">Planned for Promotion</label>
            </div>
          </div>

        </div>
      </div>
    </template>

  </search-crew-modal>
</template>

<style scoped>

</style>